import React from 'react';
import Chandni from './chandni-sahgal.png';
import Linta from './linta-antony.png';

const MeetTheExperts = () => {
    return(
        <>
            <h2 className='meet-experts-title mt-4 mb-3'>Meet the <span>experts</span></h2>
            <div className="d-flex align-items-start mb-3">
                <img className="me-2 meet-experts-img" src={Chandni} alt='' />
                <div>
                    <h5 className='meet-experts-name mb-0'>Chandni Sahgal</h5>
                    <p className='meet-experts-description mb-0'>10+ yrs |  PhD, M Sc. Food, Nutrition and Dietetics</p>
                </div>
            </div>
            <div className="d-flex align-items-start">
                <img className="me-2 meet-experts-img" src={Linta} alt='' />
                <div className='mb-4'>
                    <h5 className='meet-experts-name mb-0'>Linta Antony</h5>
                    <p className='meet-experts-description mb-0'>9 yrs |  M Sc. Food, Nutrition and Dietetics</p>
                </div>
            </div>
        </>
    );
}

export default MeetTheExperts;